import React from 'react';import Review from '../components/Review.jsx';export default function Photos(){return <Review kind="photos"/>;}
